<template>
 <div class="c-loading">

    <div class="loading loading--no-result">

      <div class="loading__img">
        <img src="/Themes/TripPlus/UI/Dist/images/noResult.svg" alt="" />
      </div>

      <div class="loading__content">
        <span class="loading__title">متاسفانه نتیجه‌ای پیدا نشد</span>

        <span class="loading__description">
          دوباره جستجو کنید یا فیلترها را تغییر دهید
        </span>        
      </div>

    </div>

</div>
</template>

<script>
export default {
  methods: {
    reLoad() {
      document.location.reload(true);
    },
  },
};
</script>
